import React, { useEffect, useState, useRef } from "react";
import * as bootstrap from "bootstrap/dist/js/bootstrap";
import siteLogo from "../../resources/site-logo-small.png";
import Masthead from "../Masthead";
import PropTypes from "prop-types";
import "../P2Header/P2Header.scss";
import { headerItems as navbarcontents, infoItems } from './P2HeaderItems';
import P2HeaderDropdown from './P2HeaderDropdown';
import WarningIcon from "../../resources/warning";
import SearchIcon from "../../resources/search";
import P2Button from "../P2Button/P2Button";
import MenuIcon from "./icons/hamburger.js";
import PolygonIcon from "./icons/polygon";
import P2MobileNavItem from './P2MobileNavItem';
export default function P2Header(props) {
  //This is to Toggle Login box
  const [isLogin, setLog] = useState(false);
  const [hoveringIndex, setHoveringIndex] = useState(-1);
  const [hoveringInfoIndex, setHoveringInfoIndex] = useState(-1);
  const navInner = useRef(null);
  const infoDropdown = useRef(null);
  const itemContainer = useRef(null);
  const mobileNavDiv = useRef(null);
  const [isMobileNavOpened, setIsMobileNavOpened] = useState(false);
  const [navHeight, setNavHeight] = useState(0);

  useEffect(() => {
    setLog(props.isAuth);
  }, [props.isAuth]);

  useEffect(() => {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltip) => {
      new bootstrap.Tooltip(tooltip);
    });
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach((popover) => {
      new bootstrap.Popover(popover);
    });
  }, []);

  useEffect(() => {
    Array.from(document.querySelector(".polymer-header-item")).forEach(itemDiv => {
      if (itemDiv.classList.contains('polymer-header-item-with-dropdown')) {
        itemDiv.addEventListener("mouseenter", () => setHoveringInfoIndex(-1));
      }
    });
  }, []);

  useEffect(() => {
    const callback = () => setNavHeight(mobileNavDiv.current.scrollHeight);
    callback();
    window.addEventListener('resize', callback);
    return () => window.removeEventListener('resize', callback);
  }, []);

  const windowLocation = window.location.href;
  return (
    <>
      <Masthead></Masthead>
      <div style={{ boxShadow: "2px 2px 5px #b7b7b7" }} className="d-print-none">
        <header
          style={{ justifyContent: "center" }}
        >
          <div className="polymer-header-top">
            <div className="polymer-header-margin" />
            <div 
              className="polymer-header-top-container"
              onMouseLeave={() => setHoveringInfoIndex(-1)}
              onMouseOver={event => {
                if (!itemContainer.current.contains(event.target) && !infoDropdown.current?.contains(event.target)) {
                  setHoveringInfoIndex(-1);
                }
              }}
            >
              <div className="polymer-header-top-content">
                <div className="polymer-site-logo">
                  <img
                    src={siteLogo}
                    alt="Housing & Development Board"
                  />
                </div>
                <div className="polymer-header-items-container" ref={itemContainer}>
                  {infoItems.map((item, itemIndex) => (
                    <div 
                      key={itemIndex}
                      className="polymer-header-item polymer-header-item-with-dropdown"
                      onMouseEnter={() => setHoveringInfoIndex(itemIndex)}
                    >
                      <a 
                        href={item.url ? item.url : windowLocation} 
                        className={"text-decoration-none" + (itemIndex === hoveringInfoIndex ? ' polymer-header-item-hovered' : '')}
                      >
                        {item.name}
                      </a>
                      {hoveringInfoIndex === itemIndex && infoItems[hoveringInfoIndex].sections && 
                      <div className="polymer-header-dropdown-pointer">
                        <PolygonIcon />
                      </div>}
                    </div>
                  ))}
                  <div
                    className="polymer-header-item"
                  >
                    {!isLogin ? (
                      <P2Button variant="login" width="115px" isLogin={isLogin} onClick={props.onClick}>
                        Login
                      </P2Button>
                    ) : (
                      <P2Button variant="login" isLogin={isLogin} width="115px" onClick={props.onClick}>
                        Logout
                      </P2Button>
                    )}
                  </div>
                  <div className="polymer-header-item display-md-block" onClick={() => setIsMobileNavOpened(state => !state)}>
                    <a>
                      <MenuIcon />
                    </a>
                  </div>
                  <div className="polymer-header-item">
                    <a>
                      <WarningIcon />
                    </a>
                  </div>
                  <div className="polymer-header-item">
                    <a>
                      <SearchIcon />
                    </a>
                  </div>
                </div>
              </div>
              {hoveringInfoIndex !== -1 && infoItems[hoveringInfoIndex].sections && 
              <div className="position-relative" ref={infoDropdown}>
                <div className="polymer-header-dropdown-container">
                  <P2HeaderDropdown 
                    item={infoItems[hoveringInfoIndex]}
                    variant="info"
                  />
                </div>
              </div>}
            </div>
            <div className="polymer-header-margin" />
          </div>
          {/* Navbar content */}
          {/* <nav className="col-12 navbar navbar-expand-lg bg-body-tertiary py-0"> */}
          <div 
            className="polymer-header-nav-wrapper"
            onMouseOver={e => {
              if (e.target.classList.contains("polymer-header-margin")) {
                setHoveringIndex(-1);
              }
            }}
            onMouseOut={e => {
              if (e.target === navInner.current) {
                setHoveringIndex(-1);
              }
            }}
            onMouseLeave={() => setHoveringIndex(-1)}
          >
            <nav
              className="col-12 navbar navbar-expand-lg py-0"
              style={{ backgroundColor: "#575757" }}
            >
              <div className="container px-0">
                <div className="collapse navbar-collapse justify-content-center" ref={navInner}>
                  <div
                    className="navbar-nav"
                    style={{ display: "flex", gap: "48px" }}
                  >
                    {navbarcontents?.map((content, linkIndex) => (
                      <a key={linkIndex} className={"nav-link" + (linkIndex === hoveringIndex ? ' polymer-header-highlighted-item' : '')} href={content.url ? content.url : windowLocation}
                        onMouseEnter={() => {
                          setHoveringIndex(linkIndex);
                        }}
                      >
                        {content.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </nav>
            {hoveringIndex !== -1 && navbarcontents[hoveringIndex].sections && <div className="position-relative">
              <div className="polymer-header-dropdown-container">
                <div className="polymer-header-margin" />
                <P2HeaderDropdown 
                  item={navbarcontents[hoveringIndex]} 
                  variant="nav"
                />
                <div className="polymer-header-margin" />
              </div>
            </div>}
          </div>
          <div className="polymer-header-mobile-nav-wrapper">
            <div 
              className="polymer-header-mobile-nav-container"
              style={{
                height: isMobileNavOpened ? navHeight : 0,
                borderWidth: isMobileNavOpened ? '1px' : '0px',
              }}
              ref={mobileNavDiv}
            >
              <div className="polymer-header-mobile-nav">
                {[...infoItems, ...navbarcontents].map((item, itemIndex) => (
                  <P2MobileNavItem key={itemIndex} item={item} resetParentHeight={(diff) => setNavHeight(height => height + diff)} />
                ))}
              </div>
            </div>
          </div>
        </header>
      </div>
    </>
  );
}

P2Header.propTypes = {
  onClick: PropTypes.func,
  isAuth: PropTypes.bool,
};

P2Header.defaultProps = {
  isAuth: true,
};
